import React from 'react'
import CartListReport from '../../../components/CardListReport/CartListReport';
import { Translate } from '../../../language';
import style from "./ReportedUserList.module.css"
const ReportedUserList = ({ listOfReports, changeReport }) => {
    return (
        <div>
            <div className={style.report_container}>
                {
                    listOfReports.map(report => (
                        <CartListReport
                            options={[
                                {
                                    text: Translate("accept", "es"),
                                    onClick: (e) => {
                                        e.stopPropagation();
                                        //     history.push("/PersonalInfo");
                                        changeReport(3, report._id,)


                                    }
                                },
                                {
                                    text: Translate("reject", "es"),
                                    onClick: (e) => {
                                        e.stopPropagation();
                                        changeReport(2, report._id)

                                    }
                                }
                            ]}
                            descriptions={report.descriptions}
                            typeOfReportsIDS={report.typeOfReportsIDS}
                            type={"entity"}
                            picture={report.reportedUserID.picture && report.reportedUserID.picture.url ? report.reportedUserID.picture.url.origin : report.reportedUserID.picture}


                            key={report._id}

                            textTwo={`Reportado por ${report.typeOfReportsIDS.length > 0 ? report.typeOfReportsIDS[0].description : report.descriptions[0].message}`}
                        />
                    ))


                }
            </div>
        </div>
    )
}

export default ReportedUserList